import { useEffect, useState } from "react";
import { Button, Dropdown, DropdownItem, DropdownMenu, Row, Table } from "reactstrap";

import { useHttpClient } from "../../../../security/hooks/axiosProvider";
import { SortDirection } from "../../../../models/SortDirection";
import hasRoles from "../../../../security/hasRoles";
import keycloak from "../../../../security/keycloak-config";
import styles from "./documentList.module.scss";
import { SupportDto } from "../../../../models/supportDto";
import { RootState } from "../../../../store";
import { useSelector } from "react-redux";
import { ThematicDto } from "../../../../models/thematicDto";
import Switch from "react-switch";
import { translate } from "react-switch-lang";

const DocumentList: React.FC<{
  t: (key: string) => {};
  data: SupportDto[];
  handleClickOpenModalViewer: (data: SupportDto) => void;
  handleClickOpenModalEditSupport: (data: SupportDto) => void;
  handleDeleteSUpport: (supportId: number) => void;
  getDocumentIconFromExtension: (path: string) => string;
  handleDownloadDocument: (data: SupportDto) => void;
  categoryId: number;
  elementPerPage: number;
  currentPage: number;
  setFilteredDocuments: (support: SupportDto[]) => void;
  setSortColumnDocument: (sortColumn: string) => void;
  setSortOrder: (order: string) => void;
  paginateAndSorting: (params: any) => void;
}> = ({
  t,
  data,
  setSortColumnDocument,
  currentPage,
  elementPerPage,
  handleClickOpenModalViewer,
  handleClickOpenModalEditSupport,
  handleDeleteSUpport,
  getDocumentIconFromExtension,
  handleDownloadDocument,
  categoryId,
  setFilteredDocuments,
  setSortOrder,
  paginateAndSorting,
}) => {
  const selectedLanguage = useSelector((state: RootState) => state.language.currentLang);
  const [sortColumn, setSortColumn] = useState("");
  const [sortIcon, setSortIcon] = useState("sort");
  const [sortDirection, setSortDirection] = useState(SortDirection.SORT);
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const httpClient = useHttpClient(false);
  const hasRoleAdmin = hasRoles(["ROLE_MEDIATHEQUE_ADMIN"], keycloak);
  const [listSupport, setListSupport] = useState([]);

  useEffect(() => {
    setListSupport(listSupport);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  function getSortIconClassName(columnName: string) {
    if (sortColumn === columnName) {
      return "fa fa-" + sortIcon;
    } else {
      return "fa fa-sort";
    }
  }
  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  };
  const sortTrainingPathList = (sortColumnName: string, isStatisticColumn: boolean) => {
    let params = { categoryId: categoryId, sortDirection: "ASC", sortColumn: sortColumnName, page: 0, size: elementPerPage };
    setSortColumn(sortColumnName);
    let asc = false;

    if (sortDirection === SortDirection.SORT || sortDirection === SortDirection.SORT_DESC || sortColumnName !== sortColumn) {
      asc = true;
      params.sortDirection = "ASC";
      setSortIcon("sort-asc");
      setSortDirection(SortDirection.SORT_ASC);
    } else {
      params.sortDirection = "DESC";
      asc = false;
      setSortIcon("sort-desc");
      setSortDirection(SortDirection.SORT_DESC);
    }
    if (isStatisticColumn) {
      asc ? setSortDirection(SortDirection.SORT_ASC) : setSortDirection(SortDirection.SORT_DESC);
      if (sortColumnName === "view") {
        data.sort(compareStatisticView);
      } else {
        data.sort(compareStatisticDownload);
      }

      if (asc) {
        data.reverse();
      }
    } else {
      setSortOrder(params.sortDirection);
      // httpClient.current?.get("/support/search", { params: params }).then(res => {
      //   setFilteredDocuments(res.data.content.map(data => data.content));
      //   asc ? setSortDirection(SortDirection.SORT_ASC) : setSortDirection(SortDirection.SORT_DESC);
      // });
      paginateAndSorting(params);
    }
  };

  const compareStatisticView = (a, b) => {
    if (a.numberView < b.numberView) {
      return -1;
    }
    if (a.numberView > b.numberView) {
      return 1;
    }
    return 0;
  };
  const compareStatisticDownload = (a, b) => {
    if (a.numberDownload < b.numberDownload) {
      return -1;
    }
    if (a.numberDownload > b.numberDownload) {
      return 1;
    }
    return 0;
  };

  const handleChangeToggleDownload = (support: SupportDto) => {
    support.download = !support.download;
    httpClient.current?.put("/support", support).then(res => {
      const listUpdated = listSupport.map(item => {
        if (item.supportId === support.supportId) {
          const updatedItem = {
            ...item,
            download: !item.download,
          };

          return updatedItem;
        }

        return item;
      });
      setListSupport(listUpdated);
    });
  };

  return (
    <div className={styles["container-table"]}>
      <Table className={styles["document-table"]}>
        <thead>
          <tr>
            <th className={styles["document-table-icon"]} scope="col"></th>
            <th className={styles["document-table-nom"]} scope="col">
              <span onClick={() => sortTrainingPathList("title", false)} className={styles["pointer"]}>
                <i className={getSortIconClassName("title")}></i> {t("table_header.title")}
              </span>
            </th>
            <th className={styles["document-table-thematique"]} scope="col">
              {t("table_header.thematic")}
            </th>
            <th className={styles["document-table-type"]} scope="col">
              <span className={styles["pointer"]}>{t("table_header.document_type")}</span>
            </th>
            <th className={styles["document-table-date"]} scope="col">
              <span onClick={() => sortTrainingPathList("dateSupport", false)} className={styles["pointer"]}>
                <i className={getSortIconClassName("dateSupport")}></i>
                {t("table_header.date")}
              </span>
            </th>
            <th className={styles["document-table-pays"]} scope="col">
              {t("table_header.country")}
            </th>
            <th className={styles["document-table-pays"]} scope="col">
              <span onClick={() => sortTrainingPathList("language", false)} className={styles["pointer"]}>
                <i className={getSortIconClassName("language")}></i> {t("table_header.language")}
              </span>
            </th>
            {hasRoleAdmin && (
              <th className={styles["document-table-pays"]} scope="col">
                <span onClick={() => sortTrainingPathList("view", true)} className={styles["pointer"]}>
                  <i className={getSortIconClassName("view")}></i> <i className="fa fa-eye"></i>
                </span>
              </th>
            )}
            {hasRoleAdmin && (
              <th className={styles["document-table-pays"]} scope="col">
                <span onClick={() => sortTrainingPathList("download", true)} className={styles["pointer"]}>
                  <i className={getSortIconClassName("download")}></i> <i className="fa fa-download"></i>
                </span>
              </th>
            )}
            {hasRoleAdmin && (
              <th className={styles["document-table-actions"]} scope="col">
                {t("table_header.downloadable")}
              </th>
            )}
            <th className={styles["document-table-actions"]} scope="col">
              {hasRoleAdmin ? t("table_header.actions") : t("table_header.download")}
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((data: SupportDto, index: number) => (
            <tr key={index + "j"}>
              <td>
                <div className={styles["card-style"] + " blog-box blog-grid text-center product-box"}>
                  <div className="product-img text-center">
                    <img
                      className={styles["document-table-image"] + " img-100 b-r-10"}
                      src={data.urlImage ? data.urlImage : getDocumentIconFromExtension(data.pathSupport)}
                      alt=""
                      onClick={() => handleClickOpenModalViewer(data)}
                    />
                    <div className={styles["product-hover"] + " product-hover"}>
                      <ul>
                        <li
                          onClick={() => {
                            handleClickOpenModalViewer(data);
                          }}
                          style={{ width: "auto" }}
                        >
                          <i className="icon-eye">
                            <span className="m-l-5">{hasRoleAdmin && data.numberView}</span>
                          </i>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </td>
              <td className="align-middle">{data.title}</td>
              <td className="align-middle">
                {data.listThematic.map((thematic: ThematicDto) => (
                  <span key={index} className="p-l-5">
                    {thematic.titleFrancais}
                  </span>
                ))}
              </td>
              <td className="align-middle">{data.documentType.titleFrancais}</td>
              <td className="align-middle">{data.dateSupport}</td>
              <td className="align-middle">
                {data.listCountry.map((country, index) => (
                  <span key={country.countryId + index} className="p-l-5">
                    {selectedLanguage === "en" ? country.titleAnglais : country.titleFrancais}
                  </span>
                ))}
              </td>
              <td className="align-middle">{data.language}</td>
              {hasRoleAdmin && <td className="align-middle">{data.numberView}</td>}
              {hasRoleAdmin && <td className="align-middle">{data.numberDownload}</td>}
              {hasRoleAdmin && (
                <td className="align-middle text-center">
                  <Switch className={styles["switch-button"]} height={20} width={40} onChange={() => handleChangeToggleDownload(data)} checked={data.download} />
                </td>
              )}

              <td className={`${styles["document-table-actions-icons"]} align-middle`}>
                {hasRoleAdmin ? (
                  <>
                    <Row className={styles["dropdown-basic"] + " dropdown-basic"}>
                      <Dropdown className={styles["dropdown"] + " dropdown"} isOpen={dropdownOpen}>
                        <div className="btn-group">
                          <Button onClick={toggle} className="text-center" color="link" outline>
                            &emsp;&emsp;&emsp;&emsp;<i className={"fa fa-ellipsis-v text-center " + styles["icon-point"]}></i>&emsp;&emsp;&emsp;
                          </Button>
                          <DropdownMenu className="dropdown-content">
                            <span className={styles["dropdown-item"] + " d-inline-block"} tabIndex={0}>
                              <DropdownItem className={styles["dropdown-item"]}>
                                <span
                                  onClick={event => {
                                    event.stopPropagation();
                                    handleClickOpenModalEditSupport(data);
                                  }}
                                >
                                  <i id="tableIconBtn" className={`${styles["document-actions__btn-update"]}  fa fa-edit`}></i>
                                  {t("button_update")}
                                </span>
                              </DropdownItem>
                            </span>
                            <span className={styles["dropdown-item"] + " d-inline-block"} tabIndex={0}>
                              <DropdownItem className={styles["dropdown-item"]}>
                                <span
                                  onClick={event => {
                                    event.stopPropagation();
                                    handleDeleteSUpport(data.supportId);
                                  }}
                                >
                                  <i id="tableIconBtn" className={`${styles["document-actions__btn-delete"]} fa fa-trash-o`}></i>
                                  {t("button_delete")}
                                </span>
                              </DropdownItem>
                            </span>
                            <span className={styles["dropdown-item"] + " d-inline-block"} tabIndex={0}>
                              <DropdownItem className={styles["dropdown-item"]}>
                                <a className={styles["link"]} href={data.urlSupport + "/download"}>
                                  <i id="tableIconBtn" className={`${styles["document-actions__btn-download-admin"]} fa fa-download`}></i>
                                  {t("button_download")}
                                </a>
                              </DropdownItem>
                            </span>
                          </DropdownMenu>
                        </div>
                      </Dropdown>
                    </Row>
                  </>
                ) : data.download ? (
                  <a onClick={() => handleDownloadDocument(data)} href={data.urlSupport + "/download"}>
                    <i className={`${styles["document-actions__btn-download-user"]} fa fa-download`}></i>
                  </a>
                ) : (
                  <i className={`${styles["document-actions__btn-download-disable"]} fa fa-download`}></i>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default translate(DocumentList);
